import { render, staticRenderFns } from "./AppointmentPage.vue?vue&type=template&id=0211bad2"
import script from "./AppointmentPage.vue?vue&type=script&lang=js"
export * from "./AppointmentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports